/*@ngInject*/
const ChangePasswordModalController = function ($rootScope, $scope, $uibModalInstance, localization, coreConstant, coreMediator, loadingBarHandler, currentUserModel, authenticationMediator) {

    localization.setupLocale('auth', require('./changePasswordModal.i18n.json'));

    $scope.title = i18n.t('auth|changePasswordModal.title');
    $scope.cancelButton = i18n.t('auth|changePasswordModal.cancelButton');
    $scope.okButton = i18n.t('auth|changePasswordModal.changePasswordButton');
    $scope.isNewPasswordFieldFocused = false;
    $scope.isVerifyPasswordFieldFocused = false;

    $scope.viewModel = {
        oldPassword: '',
        newPassword: '',
        verifyPassword: ''
    };

    $scope.onConfirm = () => {
        loadingBarHandler.showLoadingBar('changePassword.loadingBar');
        authenticationMediator.changePassword(currentUserModel.getCurrentUser().userName, $scope.viewModel.oldPassword, $scope.viewModel.newPassword).then(function (newLoginToken) {
            coreMediator.setLoginToken(newLoginToken);
            loadingBarHandler.hideLoadingBar();
            $uibModalInstance.close();
        }, function () {
            $scope.viewModel.newPassword = '';
            $scope.viewModel.oldPassword = '';
            $scope.viewModel.verifyPassword = '';
        });
    };

    $scope.onCancel = () => {
        $scope.$dismiss();
    };

    $scope.canEnableConfirmButton = () => {
        var isValid = $scope.viewModel.newPassword &&
            $scope.viewModel.oldPassword &&
            $scope.viewModel.verifyPassword &&
            $scope.viewModel.newPassword !== $scope.viewModel.oldPassword &&
            $scope.viewModel.newPassword === $scope.viewModel.verifyPassword;
        return isValid;
    };

    $scope.isNewPasswordFieldInvalid = () => {
        return !$scope.isNewPasswordFieldFocused &&
            $scope.viewModel.newPassword !== '' &&
            $scope.viewModel.oldPassword !== '' &&
            $scope.viewModel.newPassword === $scope.viewModel.oldPassword;
    };

    $scope.isVerifyPasswordFieldInvalid = () => {
        return !$scope.isVerifyPasswordFieldFocused &&
            $scope.viewModel.newPassword !== '' &&
            $scope.viewModel.verifyPassword !== '' &&
            $scope.viewModel.newPassword !== $scope.viewModel.verifyPassword;
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, () => {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-auth')
    .controller('changePasswordModalController', ChangePasswordModalController);
